var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-section"},[_c('a',{staticClass:"logo-section",attrs:{"href":"https://vivaexam.com"}},[_c('img',{staticClass:"header-logo",attrs:{"src":"/viva/viva_logo.svg","alt":"Viva Logo"}})]),_c('div',{staticClass:"empty-section"})])
}]

export { render, staticRenderFns }